import { readAdminToken } from './adminToken';
import { readTeacherSession } from './teacherSession';

export type AppRole = 'student' | 'teacher';

export const APP_ROLE_SESSION_KEY = 'gymgpt.appRole';

const USE_LIVE = import.meta.env.VITE_USE_LIVE_API === 'true';

export function parseAppRoleFromEnv(raw: string | undefined = import.meta.env.VITE_APP_ROLE): AppRole {
  if (raw === 'teacher') return 'teacher';
  return 'student';
}

export function readSessionAppRole(): AppRole | null {
  try {
    const value = sessionStorage.getItem(APP_ROLE_SESSION_KEY);
    if (value === 'teacher' || value === 'student') return value;
  } catch {
    /* sessionStorage unavailable */
  }
  return null;
}

export function writeSessionAppRole(role: AppRole): void {
  try {
    sessionStorage.setItem(APP_ROLE_SESSION_KEY, role);
  } catch {
    /* sessionStorage unavailable */
  }
}

export function resolveInitialAppRole(): AppRole {
  if (USE_LIVE) {
    return readAdminToken() || readTeacherSession() ? 'teacher' : 'student';
  }
  const stored = readSessionAppRole();
  if (stored) return stored;
  return parseAppRoleFromEnv();
}
